import { render, staticRenderFns } from "./FirmwaresOfTypeTable.vue?vue&type=template&id=2c2e0edc&scoped=true&"
import script from "./FirmwaresOfTypeTable.vue?vue&type=script&lang=js&"
export * from "./FirmwaresOfTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./FirmwaresOfTypeTable.vue?vue&type=style&index=0&id=2c2e0edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e0edc",
  null
  
)

export default component.exports